import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Report } from './report'
import { reportActions } from './report.actions'
import * as fromReport from './report.reducer'
import { ReportService } from './report.service'
import { concatMap, map, switchMap, take, tap } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class ReportEffects extends ResourceEffects<Report> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public reportService: ReportService,
    private notificationService: NotificationService
  ) {
    super(fromReport.FEATURE_NAME, reportService, reportActions, actions$)
  }

  createOneByType = createEffect(() =>
    this.actions$.pipe(
      ofType(reportActions.createOneByType),
      concatMap((action) =>
        this.reportService
          .createOneByType(action.report)
          .pipe(map((result) => reportActions.setLoading({ isLoading: false })))
      )
    )
  )
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(reportActions.resetState())})
      ),
    { dispatch: false }
  )
}
